import Box from '@mui/material/Box';
import React from 'react';

import { useDownloadFileQuery } from '@/api/v1';
import classes from '@/components/molecules/FilePreview.module.scss';
import { Header } from '@/components/organisms/Header';
import { useTranslator } from '@/hooks/useTranslator';

interface Props {
  readonly path: string | undefined;
  readonly id: string;

  onClose(): void;
}

export const FilePreview: React.FC<Props> = (props: Props): React.ReactElement => {
  const { path, id, onClose } = props;
  const { data = '' } = useDownloadFileQuery({
    path: path,
    id: id,
  });

  const tr = useTranslator();
  const url = React.useMemo((): string => {
    const blob = new Blob([data], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);

    return `${url}#toolbar=0`;
  }, [data]);

  return (
    <Box
      position="fixed"
      display="flex"
      flexDirection="column"
      left={0}
      top={0}
      width="100%"
      height="100%">
      <Header title={tr('PREVIEW')} onClose={onClose} />

      <iframe className={classes.filePreview} src={url} />
    </Box>
  );
};
